import './loginModal.scss'
import templateUrl from './loginModal.html'

/**
 * Configures a login Modal with login as option using $mdPanel
 *
 * @type {ngConfig}
 */
function TmrLoginModal($mdPanelProvider) {
  'ngInject'
  $mdPanelProvider.definePreset('loginModal', {
    templateUrl,
    controller: 'tmrLoginModalController',
    controllerAs: '$ctrl',
    panelClass: 'tmr-modal tmr-login-modal',
    clickOutsideToClose: true,
    resolve: {
      loggedUser: /*@ngInject*/ UserStorage => UserStorage.getUser(),
    },
  })
}

/**
 * Simplifies the usage of the {@link TmrLoginModal loginModal panel}
 *
 * @example <caption>In a controller</caption>
 * this.TmrLoginModal($event, username);
 *
 * @alias TmrLoginModal
 * @type {ngFactory}
 *
 * @prop {object} $event The click event passed by the template
 * @prop {string=} username The username for the login as option
 */
function TmrLoginModalFactory($mdPanel) {
  'ngInject'

  return ($event, username) => {
    let position = $mdPanel.newPanelPosition().absolute().center()
    return $mdPanel.open('loginModal', {
      openFrom: $event,
      position,
      locals: {
        loginModalUsername: username,
      },
      hasBackdrop: true,
    })
  }
}

/**
 * Controller for the panel preset loginModal
 *
 * @type {ngController}
 * @see TmrLoginModal
 */
export class tmrLoginModalController {
  static ngType = 'controller'

  constructor(mdPanelRef, loginModalUsername) {
    'ngInject'
    Object.assign(this, { mdPanelRef, loginModalUsername })
  }

  close() {
    this.mdPanelRef.close()
  }
}

export { TmrLoginModal as config }
export const factory = ['TmrLoginModal', TmrLoginModalFactory]
